<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="tipForm" label-position="top" class="tip-form">
            <!--<div class="tip-item view-item">-->
                <!--<p class="item-title view-title"><span class="required">*</span>视角：</p>-->
                <!--<el-radio-group v-model="ruleForm.checkView" @change="selectViewChange">-->
                    <!--<el-radio-button :label="1">{{$t('res.singleView')}}</el-radio-button>-->
                    <!--<el-radio-button :label="2">{{$t('res.doubleView')}}</el-radio-button>-->
                <!--</el-radio-group>-->
            <!--</div>-->
            <el-row>
                <el-col :span="8">
                    <el-form-item :label="$t('res.perspective')" prop="checkView">
                        <el-radio-group v-model="ruleForm.checkView" @change="selectViewChange">
                            <el-radio-button :label="1">{{$t('res.singleView')}}</el-radio-button>
                            <el-radio-button :label="2">{{$t('res.doubleView')}}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('paper.scorePerQuestion')" prop="topicScore">
                        <el-input-number v-model="ruleForm.topicScore" controls-position="right" size="small" :min="1"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="tip-item">
                <p class="item-title"><span class="required">*</span>{{$t('paper.safeBag')}}</p>

                            <div class="tip-num" style="height: 40px;line-height: 40px;">
                                <div class="num-title"><span class="num-name">{{$t('paper.emptyNum')}} ( {{safeTotal}} )</span> </div>

                                    <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                                    <el-form-item prop="safeCount">
                                        <el-input-number v-model="ruleForm.safeCount" controls-position="right" size="mini" :min="0" :max="safeTotal" @change="handleChange"></el-input-number>
                                    </el-form-item>
                                    <span class="num-other">{{$t('paper.ge')}}</span>
                            </div>
            </div>
            <!--左侧知识点-->
            <div class="tip-item" v-model="kpSelected">
                <p class="item-title"><span class="required">*</span>{{$t('c.knowledgePoint')}}</p>
                <p class="no-kp" v-if="kpSelected.length==0">{{$t('paper.selectKPTip')}}</p>
                <div class="kp-item" v-for="(tItem,tIndex) in kpSelected" :key="tIndex">
                    <div class="kp-top"><label class="kp-name">{{tItem.name}}</label><span class="kp-remove" @click="deleteKP(tIndex,tItem.id)" :title="$t('c.delete')"><i class="nucfont inuc-remove-circle"></i></span></div>
                    <!--<el-row :gutter="90">-->
                        <!--<el-col :span="7">-->
                    <div class="kp-content">
                            <div class="tip-num kp-left">
                                <div class="num-title"><span class="num-name">{{$t('paper.dangerNum')}} ( {{tItem.tips}} )</span> </div>
                                <div>
                                    <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                                    <el-input-number v-model="tItem.dangerNum" controls-position="right" size="mini" :min="0" :max="tItem.tips" @change="handleChange" data-type="danger"></el-input-number>
                                    <span class="num-other">{{$t('paper.ge')}}</span>
                                </div>

                            </div>
                        <!--</el-col>-->
                        <!--<el-col :span="7">-->
                            <div class="tip-num kp-left">
                                <div class="num-title"><span class="num-name">{{$t('paper.simulatedNum')}} ( {{tItem.packages}} )</span> </div>
                                <div>
                                    <span class="num-other">{{$t('paper.questionQuantity')}}</span>
                                    <el-input-number v-model="tItem.bagNum" controls-position="right" size="mini" :min="0" :max="tItem.packages" @change="handleChange" data-type="bag"></el-input-number>
                                    <span class="num-other">{{$t('paper.ge')}}</span>
                                </div>

                            </div>
                    </div>
                        <!--</el-col>-->
                    <!--</el-row>-->
                </div>

            </div>
            <div class="count" v-if="kpSelected.length>0">
                <p>
                    {{$t('paper.totalQuestions')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="totalNum"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.dao')}}
                </p>
                <p>
                    {{$t('paper.paperScore')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="ruleForm.topicScore*totalNum"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.points')}}
                </p>
                <p>
                    {{$t('paper.passingMark')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="(ruleForm.topicScore*totalNum*passLine).toFixed(1)"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.points')}}
                </p>
            </div>
        </el-form>
        <!--右侧知识点-->
        <div class="map-menu j-map-menu" :class="[kpShow ?'animated fadeInRight':'animated fadeOutRight']">
            <header class="map-title">
                <h3>{{$t('c.knowledgePoint')}}</h3>
                <i @click="kpShow=false" class="nucfont inuc-arrow-circle-right"></i>
            </header>
            <ul class="map-content">
                <li v-for="(item, index) in kpList" :key="index" @click="selectTip(index)" :class="{active:item.selected}">
                    <div class="thumbnail">
                        <div class="tip-icon"></div>
                    </div>
                    <div class="byname">{{item.name}}</div>
                </li>
        </ul>
        </div>

        <div class="btn-group" v-if="kpSelected.length>0">
            <el-button type="primary" @click="finishStep" style="padding: 14px 50px;font-size: 18px;">{{$t('paper.savePaper')}}</el-button>
        </div>
        <div class="fix-title" :class="[!kpShow ?'animated fadeInRight':'animated fadeOutUp']" @click="kpShow=true">{{$t('c.knowledgePoint')}}</div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/api';
    export default {
        props: ['passLine','paperName','pattern','type','knowledgeName','forLevel','difficulty'],
        data() {
            return {
                ruleForm: {
                    checkView: '1',
                    safeCount: 0,
                    topicScore: 2,
                },
                safeTotal: 0,
                rules: {
                    checkView: {required: true },
                    topicScore: {required: true, message: this.$t('tip.questionScore'), trigger: 'change' },
                    safeCount: {required: true, message: this.$t('paper.warnEmpty'), trigger: 'change' },
                },
                kpList: [],
                kpSelected: [],
                kpShow: true,
                totalNum: 0
            }
        },
        created() {
            this.selectViewChange(1);
        },
        computed: {
            ...mapGetters([
                'knowledgeMenu',
            ]),
        },
        methods: {
            selectViewChange(value) {
                api.getKPImageCount(value).then(res => {
                        let data=res.package;
                        this.kpList=data.kpList;
                        this.kpList.forEach(v => {
                            this.$set(v,'selected',false)
                            this.$set(v,'dangerNum',0)
                            this.$set(v,'bagNum',0)
                        })
                        this.safeTotal=data.safeCount;
                });
                this.kpSelected=[];
                this.totalNum=this.ruleForm.safeCount||0;
            },
            selectTip(index){
                if(!this.kpList[index].selected){
                    this.kpList[index].selected=true;
                    this.$set(this.kpList,index,this.kpList[index]);
                    let flag=this.kpSelected.find(v=>v.id==this.kpList[index].id)
                    if(!flag){
                        this.kpSelected.push(this.kpList[index])
                    }
                }
            },
            deleteKP(index,id){
                this.kpSelected.splice(index,1);
                this.kpList.forEach(item=>{
                    if(item.id==id){
                        item.selected=false;
                        item.dangerNum=0;
                        item.bagNum=0;
                    }
                })
                this.handleChange()
            },
            handleChange(value) {
                let totalTip=0
                this.kpSelected.forEach(item=>{
                    totalTip +=(item.dangerNum ||0) + (item.bagNum ||0);
                })
                this.totalNum=totalTip + (this.ruleForm.safeCount||0);
            },
            lastStep() {
                this.$emit('last-step');
            },
            finishStep() {
                this.$refs['tipForm'].validate((valid) => {
                    if (valid) {
                        let kpList=[];
                        let totalTip=0
                        this.kpSelected.forEach(item=>{
                            totalTip +=item.dangerNum +item.bagNum;
                            kpList.push({
                                'id':item.id,
                                'name':item.name,
                                'tips':item.dangerNum || 0,
                                'packages':item.bagNum || 0,
                            })
                        })
                        if(totalTip+this.ruleForm.safeCount==0){
                            this.$message(this.$t('paper.paperNumGtOne'));
                            return;
                        }
//                        if(totalTip>this.ruleForm.safeCount){
//                            this.$message('知识点危险品数量不能大于安全包裹数量！');
//                            return;
//                        }
                        let submitData = {
                            system:{
                                viewCount: this.ruleForm.checkView,
                                safeCount:this.ruleForm.safeCount,
                                topicScore:this.ruleForm.topicScore,
                                kpList: kpList
                            },
                            title: this.paperName,
                            forLevel: this.forLevel,
                            knowledge: this.knowledgeName[this.knowledgeName.length-1],
                            passLine: this.passLine,
                            difficulty: this.difficulty,
                            type: this.type,
                            form: this.pattern,
                        };
                        api.postTipImagePaper(submitData).then(res => {
                            this.$notify({
                                title: res.error,
                                message: this.$t('paper.buildupFast')+'!',
                                type: 'success',
                                duration: 2000
                            });
                            this.$emit('needUpdate');
                            this.$router.replace({name: 'myPaper'})
                        });
                        // console.log(submitData);
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        watch: {},
        components: {}
    }
</script>
<style lang="scss">

</style>
<style scoped lang="scss">
    .tip-item{
        padding: 7px 5px;
        &.view-item{
            padding-bottom: 12px;
        }
        .item-title{
            margin-bottom: 5px;
            &.view-title{
                margin-bottom: 15px;
            }
            .required{
                color: #ff4081;
                padding-right: 3px;
            }
        }
        .no-kp{
            text-align: center;
            margin-top: 40px;
        }
        .tip-num{
            display: flex;
            line-height: 26px;
            margin-top: 10px;
            margin-bottom: 10px;
            //width: 380px;
            &.kp-left{
                width: 368px;
                justify-content: space-between;
                margin-right: 60px;
                .num-other{
                    padding-left: 8px;
                    padding-right: 8px;
                }
                .num-title{
                    .num-name{
                        margin-right: 0px;
                    }
                }
            }

            .num-title{
                color: #fff;

                .num-name{
                    background-color: #2e7faa;
                    padding: 3px 7px;
                    margin-right: 32px;
                }
            }
            .num-other{
                padding-left: 12px;
                padding-right: 12px;
            }
        }
        .kp-item{
            margin-bottom: 10px;
            .kp-top{
                /*line-height: 40px;*/
                padding-top: 5px;
                padding-bottom: 5px;
                .kp-name{
                    display: inline-block;
                    border: 1px solid #22bdff;
                    color: #22bdff;
                    padding: 4px 8px;
                    margin-right: 15px;
                }
                .kp-remove{
                    color: #afafaf;
                    cursor: pointer;
                    &:hover{
                        i{
                            font-size: 18px;
                        }
                    }
                }
            }
            .kp-content{
                display: flex;
            }

        }
    }
    .btn-group {
        margin-top: 60px;
        margin-bottom: 15px;
    }
    .map-menu {
        position: fixed;
        display: flex;
        flex-direction: column;
        top: 210px;
        right: 0;
        bottom: 120px;
        z-index: 1000;
        width: 260px;
        padding-bottom: 32px;
        .map-title {
            flex-shrink: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 20px;
            background: #22b9ff;
            color: #fff;
            h3 {
                font-size: 18px;
                font-weight: 400;
            }
            .nucfont{
                font-size: 24px;
                border-radius: 2px;
                cursor: pointer;
                &:hover{
                    color: #e9f8ff;
                }

            }
        }
    }

    .map-menu .map-content {
        position: relative;
        flex: 1;
        width: 100%;
        padding: 5px 0 5px 0px;
        border-left: 1px solid #ababac;
        border-bottom: 1px solid #ababac;
        background: #fff;
        overflow-y: auto;
        min-height: 0;
    }

    .map-menu .map-content li {
        height: 36px;
        background: #faf9fc;
        margin-bottom: 4px;
        color: #494a4b;
        font-size: 14px;
        cursor: pointer;
    }

    .map-menu .map-content li:hover {
        background: #f4f3f8;
        color: #22b9ff;
    }

    .map-menu .map-content li:hover img {
        transform: scale(1.1);
    }

    .map-menu .map-content li.active {
        background: #f4f3f8;
        color: #22b9ff;
    }

    .map-menu .map-content li .thumbnail {
        float: left;
        display: block;
        width: 34px;
        height: 34px;
        border: 1px solid #edecef;
        overflow: hidden;
        background-color: #fff;
        margin-top: 1px;
        margin-left: 10px;
        .tip-icon{
            width: 100%;
            height: 100%;
            background: url("../../../assets/images/icon/tip-paper.png") center center no-repeat;
        }
    }


    .map-menu .map-content li .byname {
        height: 36px;
        line-height: 36px;
        padding-left: 15px;
        overflow: hidden;
    }
    .count {
        > p {
            display: inline-block;
            margin-right: 84px;
        }
    }
    .fix-title {
        position: fixed;
        top: 210px;
        right: 5px;
        padding: 6px 8px;
        background: #22b9ff;
        color: #fff;
        border-radius: 2px;
        opacity: 0;
        z-index: 100;
        cursor: pointer;
        transition: all .2s;
    }
    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
    }

    @keyframes fadeInDownBig {
        from {
            opacity: 0;
            -webkit-transform: translate3d(0, -2000px, 0);
            transform: translate3d(0, -2000px, 0);
        }
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .fadeInDownBig {
        -webkit-animation-name: fadeInDownBig;
        animation-name: fadeInDownBig;
    }

    @-webkit-keyframes fadeInRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes fadeInRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .fadeInRight {
        -webkit-animation-name: fadeInRight;
        animation-name: fadeInRight;
    }

    @-webkit-keyframes fadeOutRight {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    @keyframes fadeOutRight {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    .fadeOutRight {
        -webkit-animation-name: fadeOutRight;
        animation-name: fadeOutRight;
    }

    @-webkit-keyframes fadeOutUp {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(0, -100%, 0);
            transform: translate3d(0, -100%, 0);
        }
    }

    @keyframes fadeOutUp {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            -webkit-transform: translate3d(0, -100%, 0);
            transform: translate3d(0, -100%, 0);
        }
    }

    .fadeOutUp {
        -webkit-animation-name: fadeOutUp;
        animation-name: fadeOutUp;
    }

    .lang-en {
        .tip-num {
            width: 400px;
            &.kp-left {
                width: 388px;
            }
        }
    }
</style>
